import { render } from "./RecommendedCartProducts.vue?vue&type=template&id=39998f83&scoped=true"
import script from "./RecommendedCartProducts.vue?vue&type=script&lang=js"
export * from "./RecommendedCartProducts.vue?vue&type=script&lang=js"

import "./RecommendedCartProducts.vue?vue&type=style&index=0&id=39998f83&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39998f83"]])

export default __exports__